<template>
    <div>
        <div
            v-for="option in filter.options"
            :key="option.value"
            class="flex items-center p-4 cursor-pointer"
            @click="selectOption(option)"
        >
            <UIIcon
                v-if="option.icon"
                :icon="option.icon"
                weight="regular"
                :size="24"
                class="mr-4 text-(--color-brand-700)"
            />
            <span class="content-md-ux-medium">
                {{ option.title }}
            </span>
            <!-- The entire row is clickable so prevent potential issues with nested click handlers by disabling pointer events, it is still keyboard navigable so keep the event listener -->
            <DSwitch
                :model-value="optionStatuses[option.value]"
                class="scale-110 ml-auto pointer-events-none"
                text="left"
                @click="selectOption(option)"
            />
        </div>
    </div>
</template>
<script setup>
    import { DSwitch } from '@digistorm/spark'
    import { cloneDeep, reduce } from 'lodash'
    import UIIcon from '@/components/ui/UIIcon.vue'

    const emit = defineEmits(['update:modelValue'])

    const props = defineProps({
        filter: Object,
        modelValue: Object,
    })

    const currentValue = ref(cloneDeep(props.modelValue ?? {}))

    const optionStatuses = computed(() => {
        return reduce(currentValue.value.selected ?? [], (statuses, option) => {
            statuses[option] = true
            return statuses
        }, {})
    })

    const selectOption = (option) => {
        currentValue.value ??= {}
        currentValue.value.selected ??= []

        const isSelected = optionStatuses.value[option.value] ?? false
        currentValue.value.selected = isSelected
            ? currentValue.value.selected.filter((value) => value !== option.value)
            : [...currentValue.value.selected, option.value]

        emit(
            'update:modelValue',
            currentValue.value.selected.length
                ? currentValue.value
                : null,
        )
    }

    watch(
        () => props.modelValue,
        (newValue) => {
            if (newValue == null) {
                currentValue.value = {}
            } else {
                currentValue.value = cloneDeep(newValue)
            }
        },
    )
</script>
